export default __webpack_public_path__ + "static/media/institute-17-min.3cb5def9.webp";